import React, { forwardRef, useMemo } from "react";
import _, { omit } from "lodash";
import { Form, Tooltip } from "antd";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { FieldTypes, nameRegexValidator, urlRegexValidator } from "utils/formUtils";
import message from "components/CustomMessage";
import { HelpSolidIcon } from "components/Icons";
import BaseModalForm from "components/BaseModalForm";
import { duplicateNameValidator } from "utils/validatorUtil";


const BackstageConfigForm = forwardRef( ({afterClose, configData, onUpdateConfigComponent, ...props}, ref) => {
    const [form] = Form.useForm();
    const {configList} = props;
    const isEdit = !_.isUndefined(configData);

    const submitData = async (data) => {
        let payload = data;
        payload = omit({
          ...payload,
          configType: "BACKSTAGE",
          config:{
              authToken: payload.authToken,
              baseUrl: payload.baseUrl,
          }
        }, ["authToken", "baseUrl"]);

        if(isEdit) {
            const dataToSend = { ...payload, id: configData.id};
            await ToolsIntegrationsAPI.updateGenericConfigDetails(dataToSend).promise;
            message.success(`Successfully updated.`);
          } else {
            await ToolsIntegrationsAPI.postGenericLoginDetails(payload).promise;
            message.success(`Successfully configured.`);
        }
        onUpdateConfigComponent && onUpdateConfigComponent(true);

      };


    const baseModalProps = {
        okText: "Configure",
    }

    
    const fields = useMemo(() => [
        {
            name: "name",
            label: "Name",
            props: {
                autoFocus: true
            },
            colSpan: 24,
            required: true,
            disabled: isEdit, 
            rules: [
                nameRegexValidator,
                duplicateNameValidator({ list: configList }),
            ],
        },
        {
            name: "baseUrl",
            label: "Base Url",
            rules: [urlRegexValidator()],
            colSpan: 24,
            required: true,
        },
        {
            name: "authToken",
            label: "Token",
            help: "Enter a valid token or Generate it",
            type: FieldTypes.PASSWORD,
            labelAlign: "left",
            colSpan: 24,
            required: true,
        },

    ], [configList, isEdit])


    return (
        <BaseModalForm             
            modalProps={baseModalProps}
            ref={ref}
            form={form} 
            fields={fields}
            onOk={submitData}
            afterClose={afterClose}
            title= {`Configure ${_.replace(props?.id, "_", " ")}`}
            initialValues={ { baseUrl: isEdit ? configData.hostUrl: "" , name: configData?.name} }
        />
    )
})

export default BackstageConfigForm
